<template>
    <span v-if="error" class="mx-4 font-medium text-md text-red-500">{{error}}</span>
</template>

<script>
    export default {
        computed: {
            error() {
                return this.$page.props.errors?this.$page.props.errors.exception:false
            },
        }
    }
</script>
